import React from 'react';
import { PropTypes } from 'prop-types';
import Loading from '../../../components/Loading';
import Player from './DashboardPlayer';
import AddPlayerButton from '../../../components/AddItemFloatingActionButton';

const Dashboard = ({ loading, onAddPlayer, onStartCoding, players }) => (
  <div>
    {loading ? (
      <Loading />
    ) : players.count() > 0 ? (
      <div>
        {players
          .entrySeq()
          .map(([key, player]) => (
            <Player
              key={key}
              newGameLink={`/games/new?playerId=${key}`}
              player={player}
              playerDetailsLink={`/players/${key}/details`}
              onStartCoding={onStartCoding}
            />
          ))}
      </div>
    ) : (
      <div>No players found</div>
    )}

    <AddPlayerButton onClick={onAddPlayer} />
  </div>
);

Dashboard.propTypes = {
  loading: PropTypes.bool.isRequired,
  onAddPlayer: PropTypes.func.isRequired,
  onStartCoding: PropTypes.func.isRequired,
  players: PropTypes.object.isRequired
};

export default Dashboard;



// WEBPACK FOOTER //
// ./src/routes/home/components/Dashboard.js